export const getMobilePlacements = (isAdblockEnabled: boolean) => [
    {
        id: 'board_1',
        invCode: 'no-e24-wph-front_board_1',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
            [1920, 1080],
        ],
        allowedFormats: ['native', 'banner'],
        keywords: {
            'no-sno-adformat': ['board_1', 'board_fullscreen'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_2',
        invCode: 'no-e24-wph-front_board_2',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
        ],
        allowedFormats: ['native', 'banner'],
        keywords: {
            'no-sno-adformat': ['board_2'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_3',
        invCode: 'no-e24-wph-front_board_3',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
            [1920, 1080],
        ],
        allowedFormats: ['native', 'banner'],
        keywords: {
            'no-sno-adformat': ['board_3', 'board_fullscreen'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_4',
        invCode: 'no-e24-wph-front_board_4',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
        ],
        allowedFormats: ['native', 'banner'],
        keywords: {
            'no-sno-adformat': ['board_4'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_5',
        invCode: 'no-e24-wph-front_board_5',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
        ],
        allowedFormats: ['native', 'banner'],
        keywords: {
            'no-sno-adformat': ['board_5'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_6',
        invCode: 'no-e24-wph-front_board_6',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
        ],
        allowedFormats: ['native', 'banner'],
        keywords: {
            'no-sno-adformat': ['board_6'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_backfill_1',
        invCode: 'no-e24-wph-front_board_backfill_1',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 200],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
        ],
        allowedFormats: ['native', 'banner'],
        finnBlink: {
            enabled: true,
            position: isAdblockEnabled
                ? 'hayabusa_board_backfill_1_front'
                : 'board_backfill_1_front',
        },
        keywords: {
            'no-sno-adformat': ['board_backfill_1'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_backfill_2',
        invCode: 'no-e24-wph-front_board_backfill_2',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 200],
            [320, 400],
            [1, 1],
            [3, 3],
            [5, 250],
            [5, 400],
        ],
        allowedFormats: ['native', 'banner'],
        finnBlink: {
            enabled: true,
            position: isAdblockEnabled
                ? 'hayabusa_board_backfill_2_front'
                : 'board_backfill_2_front',
        },
        format: ['board_backfill_2'],
        keywords: {
            'no-sno-adformat': ['board_backfill_2'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_backfill_3',
        invCode: 'no-e24-wph-front_board_backfill_3',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
        ],
        allowedFormats: ['native', 'banner'],
        finnBlink: {
            enabled: true,
            position: isAdblockEnabled
                ? 'hayabusa_board_backfill_3_front'
                : 'board_backfill_3_front',
        },
        keywords: {
            'no-sno-adformat': ['board_backfill_3'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_backfill_4',
        invCode: 'no-e24-wph-front_board_backfill_4',
        subtype: 'netboard',
        sizes: [
            [320, 250],
            [300, 250],
            [320, 400],
            [1, 1],
            [5, 250],
            [5, 400],
        ],
        allowedFormats: ['native', 'banner'],
        finnBlink: {
            enabled: true,
            position: isAdblockEnabled
                ? 'hayabusa_board_backfill_4_front'
                : 'board_backfill_4_front',
        },
        keywords: {
            'no-sno-adformat': ['board_backfill_4'],
        },
        safeframe: true,
        videoEnabled: true,
    },
    {
        id: 'board_jobs',
        invCode: 'no-e24-wph-front_board_jobs',
        subtype: 'netboard',
        sizes: [
            [5, 345],
            [2, 1],
        ],
        allowedFormats: ['banner'],
        keywords: {
            'no-sno-adformat': ['board_jobs'],
        },
        safeframeConfig: {
            allowExpansionByPush: true,
            allowExpansionByOverlay: true,
        },
    },
];
